<div class="container-fluid">
  <h4 class="mt-1">Noticias</h4>
  <div class="row mb-1">
    <img class="img-fluid mx-auto" style="max-height: 75vh" src="../../assets/images/admision_digital.jpg"/>
  </div>
</div>